export var DirectionEnum;
(function (DirectionEnum) {
    DirectionEnum["ASC"] = "ASC";
    DirectionEnum["DESC"] = "DESC";
})(DirectionEnum || (DirectionEnum = {}));
export class LimitOffsetPaginationDto {
    limit;
    offset;
    orderDirection;
    orderBy;
}
export var OrderDirectionEnum;
(function (OrderDirectionEnum) {
    OrderDirectionEnum[OrderDirectionEnum["ASC"] = 1] = "ASC";
    OrderDirectionEnum[OrderDirectionEnum["DESC"] = -1] = "DESC";
})(OrderDirectionEnum || (OrderDirectionEnum = {}));
export var OrderByEnum;
(function (OrderByEnum) {
    OrderByEnum["ASC"] = "ASC";
    OrderByEnum["DESC"] = "DESC";
})(OrderByEnum || (OrderByEnum = {}));
//# sourceMappingURL=response.js.map